import { useState, useCallback } from "react";

/**
 * Hook for managing a set of collapsible items
 * @param initialCollapsed - Items that should be collapsed initially
 */
export function useCollapsibleSet(initialCollapsed?: Iterable<string>) {
  const [collapsed, setCollapsed] = useState<Set<string>>(
    new Set(initialCollapsed)
  );

  const toggle = useCallback((item: string) => {
    setCollapsed((prev) => {
      const next = new Set(prev);
      if (next.has(item)) {
        next.delete(item);
      } else {
        next.add(item);
      }
      return next;
    });
  }, []);

  const isCollapsed = useCallback(
    (item: string) => collapsed.has(item),
    [collapsed]
  );

  const collapseAll = useCallback((items: string[]) => {
    setCollapsed(new Set(items));
  }, []);

  const expandAll = useCallback(() => {
    setCollapsed(new Set());
  }, []);

  return {
    collapsed,
    toggle,
    isCollapsed,
    collapseAll,
    expandAll,
  };
}
